import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import ApiUrls from '../../services/apiUrls';

export default class BusCompanies extends Component {
  static propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
    metaData: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // this.props.actions.getSiteMap({ url: ApiUrls.siteMap() });

    this.setState({
      companies: this.props && this.props.siteMap && this.props.siteMap.seo_op_details && this.props.siteMap.seo_op_details.slice(0, 49),
    });
  }

  // <a
  //               href = `https://kupos.cl/${i18next.language}/${this.props.t('HOME.SITEMAP_TICKET')}/$
  //               {val[2].split('/')[2]}|&nbsp;`>
  //             </a>

  renderCompanies = () => {
    return (
      <div>
        {this.state.companies &&
          this.state.companies.map((val, key) => {
            let newLink = `https://kupos.cl/${i18next.language === 'es' ? val[2] : val[1]}`;
            return (
              <a href={newLink} target="_blank">
                {val[0]} {key === this.state.companies.length - 1 ? '' : ' | '}
              </a>
            );
          })}
      </div>
    );
  };

  render() {
    const { t, history, metaData } = this.props;
    return (
      <div className="home-bus-companies">
        <div className="bus-companies-item font18">
          {t('HOME.BUS_COMPANIES.NORMAL')}
          <span className="kupos-description-heading bold-text">
            {' '}
            {t('HOME.BUS_COMPANIES.BOLD')}
          </span>
        </div>

        {/* {console.log('Web Url is', metaData ? metaData.web_url : 'error')} */}

        <div className="bus-companies content-container font11">
          {this.renderCompanies()}
          <a
            className="bus-companies-select-more"
            onClick={() => history.push(`/${i18next.language}/site-map`)}
          >
            <span>
              <img
                src="/static/images/icons/home/icon-right-arrow-bold.png"
                alt={this.props.t('TRANSLATIONS.ICON_RIGHT3')}
              />
              &nbsp;
            </span>
            <span className="destination-routes-more-option bold-text primary-text">
              {this.props.t('HOME.MORE')}
            </span>
          </a>{' '}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/BusCompanies.js